export default __webpack_public_path__ + "static/gallery2-1931d94b81e2520d6316445f94cc9109.jpg";